'use client'

import {SDivider} from "@/components/atoms/divider";
import {Section} from "@/components/atoms/sections";
import {Title, TitleLabel} from "@/components/atoms/typographies";
import {AsideLayout, ContentLayout} from "@/components/molecules/layouts";
import {SignUpInput, useSignupMutation} from "@/lib/client/slices/users";
import {useForm} from "react-hook-form";
import {
  ControlledButtonSubmit,
  ControlledCheckbox,
  ControlledForm,
  ControlledInputPassword,
  ControlledInputText
} from "@/components/molecules/form";
import {RegisterOptionOrganization} from "./_components/register_option_organization";
import Link from "next/link";
import {ResponseStatusMessage} from "@/components/atoms/ResponseStatusMessage";
import {useReCaptcha} from "next-recaptcha-v3";
import {useCallback} from "react";
import { Ad } from "@/components/atoms/ad";

export default function RegisterPage() {
  const {executeRecaptcha} = useReCaptcha();
  const form = useForm<SignUpInput>()
  const [signup, status] = useSignupMutation()

  const handleSubmit = useCallback((data: SignUpInput) => {
    executeRecaptcha("form_register")
      .then(token => signup({...data, token: token}))
      .then((r: any) => {
        if (!r.error) {
          window.location.href = `/confirm-account?email=${data.email}`
          return
        }
      })
  }, [executeRecaptcha, signup]);

  return (<>
    <ContentLayout>
      <Title>Créer un compte</Title>
      <TitleLabel>Rejoignez la communauté, créez votre compte</TitleLabel>
      <SDivider/>

      <Section container>
        <ResponseStatusMessage status={status}
                               successMessage="Inscription réussie. Redirection en cours..."
                               loadingMessage={"Inscription en cours..."}/>

        <ControlledForm useForm={form} onSubmit={form.handleSubmit(handleSubmit)}>
          <div className={'flex flex-col justify-center items-center m-2 p-2'}>
            <div>
              <ControlledInputText disabled={status.isSuccess} useForm={form} required={true}
                                   label={"Nom public ou d'organisation"} name={"display_name"}/>
              <ControlledInputText disabled={status.isSuccess} useForm={form} required={true} label={"Email"}
                                   name={"email"}/>
              <ControlledInputPassword disabled={status.isSuccess} useForm={form} required={true} label={"Mot de passe"}
                                       name={"password"}/>
              <ControlledInputPassword disabled={status.isSuccess} useForm={form} required={true}
                                       label={"Confirmer le mot de passe"} name={"confirm_password"}/>
              <RegisterOptionOrganization useForm={form} disabled={status.isSuccess}/>
              <ControlledCheckbox disabled={status.isSuccess} useForm={form} required={true} name={"cgu"}>
                <span>J'accepte les <Link href={"/pages/conditions-generales-utilisation"} target="_blank">conditions générales d'utilisation</Link></span>
              </ControlledCheckbox>
            </div>
            <ControlledButtonSubmit useForm={form} loading={status.isLoading} disabled={status.isSuccess}
                                    label={"Créer mon compte"}/>
          </div>
        </ControlledForm>

      </Section>

    </ContentLayout>
    <AsideLayout>
    <Section className="flex justify-center">
        <Ad format={'pave'}/>
      </Section>
    </AsideLayout>
  </>)
}
